export const ROLE_NAMES = {
  'admin': 'עו"ד ראשי',
  'secretary': 'מזכירות',
  'lawyer': 'עו"ד',
  'intern': 'מתמחה'
};

export const formatHebDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return dateStr;
};

export const handleDownloadLocalFile = (docObj, e) => {
  if (e) e.stopPropagation();
  if (docObj.fileUrl) {
    const link = document.createElement('a');
    link.href = docObj.fileUrl;
    link.download = docObj.name;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
  }
  
  const content = `--- מסמך מערכת ---\nשם הקובץ: ${docObj.name}\nסיווג: ${docObj.securityLevel || 'רגיל'}\nהועלה על ידי: ${docObj.uploadedBy || 'מערכת'}\nתאריך: ${formatHebDate(docObj.date)}\n\n(קובץ זה הועלה לפני חיבור מנגנון האחסון האמיתי ולכן אינו מכיל נתונים)`;
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = docObj.name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
